<div>
  <div class="cardHeading">
    <div class="chartHeading">
      <div class="cardHeading lato-bold-dark">Records Journey • {{ displayName }}</div>
      <div class="cardDetails lato-regular-light">{{ stackContainersDetails }}</div>
      <!-- <app-engagement-stackbar></app-engagement-stackbar> -->
    </div>
    <div class="cardFilter">
      <!-- <app-ltms-widget-tools></app-ltms-widget-tools> -->
      <app-ltms-widget-tools [config]='widgetConfigbarGraph'></app-ltms-widget-tools>
    </div>
  </div>
  
  <div class="stack-containers" *ngIf="isDataLoaded; else loader">
    <div class="stack-container" *ngFor="let data of recordsJourneyData">
      <div>
        <div class="filled-bar">
          <div class="empty-bar" [style.height]="data.percentage"></div>
        </div>
        <div class="text">
          <div class="value" *ngIf="data">
            {{ data["current"] | indianNumberFormat }}
          </div>
          <div class="comparison-row" *ngIf="isDeviationEnabled && comparisonLabel">
            <span class="comparison-label">vs {{ comparisonLabel }}</span>
            <span class="stack-deviation"
              *ngIf="data.deviation != null"
              [ngClass]="{
                'deviation-up': data.deviation.arrowType === 'up',
                'deviation-down': data.deviation.arrowType === 'down',
                'deviation-no-change': data.deviation.arrowType === 'no-change'
              }">
              {{ data.deviation.deviation }}<i *ngIf="data.deviation.arrowType === 'up'" class="fa fa-arrow-up deviation-arrow"></i><i *ngIf="data.deviation.arrowType === 'down'" class="fa fa-arrow-down deviation-arrow"></i>
            </span>
          </div>
          <div class="label">{{data.name}}</div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #loader>
    <div class="data-details-loader">
      <app-ltms-loader></app-ltms-loader>
    </div>
  </ng-template> 
</div>